import { Button } from "antd";
import DeleteIcon from "components/Icons/DeleteIcon";
import { IPlace } from "models/place";
import DeleteModal from "./DeleteModal";
import { useState } from "react";

interface IProps {
  place: IPlace;
  handleReload: () => void;
}

export default function PlaceInfo({ place, handleReload }: IProps) {
  const [open, setOpen] = useState<boolean>(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div className="w-full flex flex-col gap-y-3">
      <DeleteModal
        place={place}
        open={open}
        handleClose={handleClose}
        handleReload={handleReload}
      />
      <div className="w-full flex justify-end">
        <Button
          type="text"
          danger
          size="small"
          shape="circle"
          className="flex justify-center items-center"
          onClick={handleOpen}
        >
          <DeleteIcon />
        </Button>
      </div>
      <h1 className="mt-1 text-black font-semibold text-base">{place.name}</h1>
    </div>
  );
}
